import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConsentBanner } from "@/components/site/ConsentBanner";
import { ErrorBoundary } from "@/components/site/ErrorBoundary";
import Landing from "@/pages/Landing";
import OmCaroline from "@/pages/OmCaroline";
import PlanDetail from "@/pages/PlanDetail";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Unsubscribe from "@/pages/Unsubscribe";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <AuthProvider>
      <ErrorBoundary>
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/om-caroline" element={<OmCaroline />} />
            <Route path="/plan/:slug" element={<PlanDetail />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/personvern" element={<Privacy />} />
            <Route path="/vilkar" element={<Terms />} />
            <Route path="/avmelding" element={<Unsubscribe />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ConsentBanner />
        </BrowserRouter>
      </ErrorBoundary>
    </AuthProvider>
  );
}

export default App;
